// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"132":"b858905d","354":"c55f1c10","838":"980786c3"}[chunkId] + ".js";
};